import { createUseStyles, subtract } from '@pushpay/styles';
import { GivingOldTheme, isGivingOldTheme } from '@pushpay/theming';
import { headerHeight, headerHeightMobile } from '../header';
export const useStyles = createUseStyles(theme => {
  const isGivingOld = theme.colors['product-color'] === GivingOldTheme.colors['product-color'];
  return {
    root: ({
      isMobile = false
    }) => ({
      position: isMobile ? 'static' : 'relative',
      '&:hover, &:focus': {
        backgroundColor: `${isGivingOld ? 'unset' : theme.colors['color-background-page']}`
      },
      display: 'inline-flex',
      height: subtract(headerHeight, 1),
      ...(!isMobile && {
        padding: `6px ${theme.SPACING.XSMALL}`
      })
    }),
    button: ({
      isMobile
    }) => ({
      verticalAlign: 'middle',
      ...(isMobile && {
        paddingLeft: theme.SPACING.XSMALL
      })
    }),
    header: {
      padding: theme.SPACING.SMALL,
      display: 'flex',
      justifyContent: 'space-between'
    },
    title: {
      font: theme.TYPOGRAPHY.HEADLINE_3,
      fontWeight: 'bold'
    },
    noOrgAccessTitle: {
      padding: `${theme.SPACING.GUTTER} ${theme.SPACING.SMALL}`,
      font: theme.TYPOGRAPHY.HEADLINE_4
    },
    noOrgAccessLockIcon: {
      color: theme.colors['palette-grey']
    },
    marketingLink: {
      color: theme.colors['color-text-default'],
      textDecoration: 'none',
      display: 'flex',
      alignItems: 'center',
      padding: `0 ${theme.SPACING.XXSMALL}`,
      ...theme.OUTLINE.INTERACTIVE_ELEMENT_FOCUS_VISIBLE,
      '&:hover, &:focus': {
        color: theme.colors['color-text-default'],
        textDecoration: 'underline'
      }
    },
    panel: {
      font: theme.TYPOGRAPHY.BODY_1,
      color: theme.colors['color-text-default'],
      backgroundColor: theme.colors['color-background-surface'],
      minWidth: '320px',
      display: 'flex',
      flexDirection: 'column',
      borderRadius: theme.SHAPE.ROUNDED_CORNERS
    },
    item: {},
    itemIcon: ({
      orgHasProduct
    }) => ({
      fontSize: '28px',
      color: orgHasProduct ? undefined : theme.colors['palette-grey']
    }),
    currentProductItemIcon: ({
      currentProductDisplayStyle,
      isMobile
    }) => ({
      fontSize: '40px',
      marginRight: isMobile || currentProductDisplayStyle === 'icon' ? 0 : theme.SPACING.SMALL
    }),
    currentItem: {},
    activeItem: {},
    learnMore: {
      font: theme.TYPOGRAPHY.BODY_2,
      '&:hover, &:focus': {
        color: isGivingOldTheme(theme) ? theme.colors['palette-blue'] : undefined
      },
      fontSize: '16px'
    },
    noAccessTooltipContainer: {
      paddingLeft: theme.SPACING.GUTTER
    },
    noAccessTooltipPanel: {
      font: theme.TYPOGRAPHY.TAGS,
      zIndex: theme.ELEVATION.MODAL.Z_INDEX + theme.ELEVATION.POPOVER.Z_INDEX
    },
    noAccessTooltipPanelContent: {
      width: '200px'
    },
    noAccessItem: {
      color: theme.colors['palette-grey-dark-200']
    },
    noOrgAccessItem: {},
    noAccessLabel: {
      display: 'flex',
      alignItems: 'center'
    },
    noAccessDescription: {
      font: theme.TYPOGRAPHY.TAGS,
      color: theme.colors['palette-grey-dark-300']
    },
    noAccessDividerContainer: {
      padding: '12px 20px 0px 20px'
    },
    noAccessDivider: {
      margin: 0,
      padding: 0,
      border: 'none',
      height: '1px',
      backgroundColor: theme.colors['palette-grey-light-200']
    },
    currentProduct: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      maxWidth: '180px'
    },
    currentProductLabel: ({
      isMobile = false
    }) => ({
      color: theme.colors['color-text-heading'],
      fontSize: `${isMobile ? '18px' : '20px'}`,
      margin: 0
    }),
    productSwitcherMobileOverlay: {
      top: 'auto',
      left: 0,
      right: 0,
      marginTop: subtract(headerHeightMobile, '1px'),
      borderRadius: 0
    }
  };
});